
import { isJSON } from "@/utils";
import { getGateWayToken } from '@/services'
export function retry(instance, error) {
  const config = error.config
  const { waitTime, count } = config.retryConfig || {}
  config.currentCount = config.currentCount || 0
  console.log(`第${config.currentCount}次重连`)
  if (config.currentCount >= count) {
    return Promise.reject(error)
  }
  config.currentCount++
  console.log('重复请求的 conifg', config)
  return wait(waitTime).then(() => instance(config))
}

/**
 * @description 重新发送被token过期而cancel的请求
 * @param axiosInstance axios实例
 * @param config 请求配置
 * @returns
 */
export const requestReplayWithNewIdToken = async (axiosInstance, error) => {
  const config = error.config;
  // 重新获取云端服务的 token
  // 并存储到本地
  config.replay = config.currentCount >= config.retryConfig?.count ? true : false;
  let authorization, realm;
  if (config.needGateWayToken) {
     // 授权
     let authorization = ''
     authorization = document.cookie.replace(
       /(?:(?:^|.*;\s*)slbrowser_mobile_ai_assist_authorization\s*\=\s*([^;]*).*$)|^.*$/,
       "$1")
     if (!authorization) {
       authorization = await getGateWayToken()
     }
  }
  const keepHeaders = ['Content-Type', 'token', 'realm']// 新的 Authorization 值
    .reduce((result, key) => {
      if (key === 'token') {
        result[key] = `Bearer ${authorization}`;
      } else if (key === 'realm') {
        result[key] = realm;
      } else {
        result[key] = config.headers[key];
      }
      return result;
    }, {})
  config.headers = keepHeaders;
  if (typeof config?.data === 'string' && isJSON(config?.data)) {
    config.data = JSON.parse(config.data);
  }
  // 在获取到新的token后，调用retry函数，重新发送请求 count次
  return retry(axiosInstance, error)
}
// waitTime 事件后，调用resolve
function wait(waitTime) {
  return new Promise(resolve => setTimeout(resolve, waitTime))
}
